import axios from 'axios';

const registerDevice = async (force = false) => {
  if (localStorage.getItem('devicePid')) return;

  const payload = {
    appType: "web",
    cpu: 8,
    ram: "16GB",
    browserName: "Chrome",
    host: "localhost",
    screenSize: "1920x1080",
    fontScale: 1.0,
    deviceType: "desktop",
    osProvider: "Windows",
    osVersion: "11",
    platform: "Win32",
    appBuildVersion: 1,
    networkType: "wifi",
    downlink: "10",
    networkRtt: "50",
  };

  const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/devices/register`, payload);
  localStorage.setItem('devicePid', response.data.response.devicePid);
};

export default registerDevice;
